import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-home-case-study-section',
  standalone: true,
  templateUrl: './home-case-study-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeCaseStudySectionComponent {}
